import { apiSports } from '@spo/services/api';
import { useMutation } from '@tanstack/react-query';

export const usePatchSportSettings = (
  sportId: number,
  genderIds: number[],
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['usePatchSportSettings', genderIds],
    mutationFn: () =>
      apiSports.patchSportSettings({
        sportId,
        genderIds,
        language: 'EN',
      }),
    onSuccess,
    onError,
  });
};
